import React from "react";
import "./../css/Banner.css";
import { API } from "./../utils/helper";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useLoadingOverlay } from "./LoadingOverlayProvider";
import { ToastColor, ToastPlacement } from "./../utils/types";

export default function Banner({
  title,
  withIcons = true,
}: {
  title: string;
  withIcons?: boolean;
}) {
  const { loadingIncrement, loadingDecrement, showToast } = useLoadingOverlay();
  const username = window.sessionStorage.getItem("username");
  const companyProfileId = window.sessionStorage.getItem("companyProfileId");
  const individualProfileId = window.sessionStorage.getItem(
    "individualProfileId"
  );
  const navigate = useNavigate();
  let isAuthenticated = !!window.sessionStorage.getItem("token");
  const excludedRoutes = [
    "/",
    "/registration/individual",
    "/registration/corporate",
    "/registration/traders-channel-partner",
    "/auth/code",
    "/auth/forgot",
    "/auth/forgot/reset",
    "/auth/forgot/new",
  ];
  const isOnExludedRoutes = excludedRoutes.includes(window.location.pathname);
  const showUserIcons = React.useMemo(() => {
    return isAuthenticated && !isOnExludedRoutes && withIcons;
  }, [isAuthenticated, isOnExludedRoutes, withIcons]);
  const profile = React.useMemo(() => {
    if (Number(individualProfileId)) {
      return "/individual";
    } else if (Number(companyProfileId)) {
      return "/corporate";
    } else {
      return "/individual";
    }
  }, [individualProfileId, companyProfileId]);

  const logout = () => {
    loadingIncrement();
    const refId = sessionStorage.getItem("refId");
    if (!refId) {
      sessionStorage.clear();
      loadingDecrement();
    }

    axios
      .get(API + `/logout/deletelogin/${refId}`)
      .then((response) => {
        // if (response.data === 1) {
        sessionStorage.clear();
        navigate("/");
        // }
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          navigate(
            `/?redirectUrl=${window.location.pathname + window.location.search}`
          );
        }
        showToast({
          color: ToastColor.Danger,
          closeButton: true,
          title:
            error?.response?.data?.message ||
            error?.response?.data ||
            "Failed to logout.",
          placement: ToastPlacement.TopRight,
          timeout: 3000,
          timed: true,
        });
      })
      .finally(() => {
        loadingDecrement();
      });
  };

  return (
    <>
      <header className="banner relative">
        <div className="flex">
          <div className="grow flex justify-center">
            <h1 className="text-xl text-white font-normal text-center">
              {title}
            </h1>
          </div>
          {showUserIcons && (
            <div className="w-fit flex gap-3">
              <a href={`/profile${profile}`} className="text-white font-normal">
                {username}{" "}
                <i className="bi bi-person" style={{ color: "white" }}></i>
              </a>
              <button onClick={logout}>
                <i
                  className="bi bi-box-arrow-right"
                  style={{ color: "white" }}
                ></i>
              </button>
            </div>
          )}
        </div>
      </header>
    </>
  );
}
